import React, { useState } from 'react';
import axios from 'axios';
import './AssignRole.css';

const AssignRole = () => {
  const [roleId, setRoleId] = useState('');
  const [userId, setUserId] = useState('');
  const [message, setMessage] = useState('');
  const [assignments, setAssignments] = useState([]);
  const [showAssignments, setShowAssignments] = useState(false);
  const [isCentered, setIsCentered] = useState(true); // State to track if form is centered

  const checkUserRole = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/check-user-role?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error checking user role:', error);
      return null;
    }
  };

  const handleCreate = async () => {
    if (!roleId || !userId) {
      setMessage('Please provide both Role ID and User ID');
      return;
    }

    try {
      const userRole = await checkUserRole();
      if (userRole) {
        setMessage(`User ${userId} already has a role assigned: ${userRole.roleId}`);
        return;
      }

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/assign-role`, { roleId, userId });
      setMessage('Role successfully assigned');
    } catch (error) {
      setMessage('Error creating role assignment');
      console.error('Error creating role assignment:', error);
    }
  };

  const handleUpdate = async () => {
    if (!roleId || !userId) {
      setMessage('Please provide both Role ID and User ID');
      return;
    }

    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/assign-role`, { roleId, userId });
      setMessage('Role assignment updated');
    } catch (error) {
      setMessage('Error updating role assignment');
      console.error('Error updating role assignment:', error);
    }
  };

  const handleRetrieveRoleDetails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/assign-role?roleId=${roleId}`);
      if (response.data) {
        setUserId(response.data.userId);
        setMessage(`Role ${roleId} is assigned to user ${response.data.userId}`);
      } else {
        setMessage('No assignment found for this role ID');
      }
    } catch (error) {
      setMessage('Error retrieving role assignment');
      console.error('Error retrieving role assignment:', error);
    }
  };

  const handleView = async () => {
    try {
      if (showAssignments) {
        setShowAssignments(false);
        setAssignments([]);
        setIsCentered(true); // Center the form again
      } else {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/assign-role/view`);
        setAssignments(response.data || []);
        setShowAssignments(true);
        setIsCentered(false); // Move the form to the left
        setMessage('');
      }
    } catch (error) {
      setMessage('Error retrieving role assignments');
      console.error('Error retrieving role assignments:', error);
    }
  };

  const handleDelete = async () => {
    if (!roleId || !userId) {
      setMessage('Please provide both Role ID and User ID');
      return;
    }

    try {
      await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/assign-role`, { params: { userId, roleId } });
      setMessage('Role assignment deleted');
    } catch (error) {
      setMessage('Error deleting role assignment');
      console.error('Error deleting role assignment:', error);
    }
  };

  return (
    <div className="assign-role-container">
      
      <div className="assign-role-content">
        <div className={`form-container ${isCentered ? 'centered' : ''}`}>
          <div className="form-group">
            <h2>Assign Role</h2>
            <label>Role ID</label>
            <input
              type="text"
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
              onBlur={handleRetrieveRoleDetails}
            />
          </div>
          <div className="form-group">
            <label>User ID</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </div>
          {message && <p className="message">{message}</p>}
          <div className="button-group">
            <button className="btn" onClick={handleCreate}>Create</button>
            <button className="btn" onClick={handleUpdate}>Edit</button>
            <button className="btn" onClick={handleDelete}>Remove</button>
            <button className="btn" onClick={handleView}>{showAssignments ? 'Hide All' : 'View All'}</button>
          </div>
        </div>
        
        {!isCentered && showAssignments && (
          <div className="assignments-container">
            <h3>Role Assignments</h3>
            {assignments.length > 0 ? (
              <table className="assignments-table">
                <thead>
                  <tr>
                    <th>Role ID</th>
                    <th>User ID</th>
                  </tr>
                </thead>
                <tbody>
                  {assignments.map((assignment, index) => (
                    <tr key={index}>
                      <td>{assignment.roleId}</td>
                      <td>{assignment.userId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No role assignments to display.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignRole;
